// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag_wrapper","label":"Tag_label","closeIcon":"Tag_closeIcon"};